{
    "Accessibility menu": "Menu accessibilità",
    "Close": "Chiudi",
    "Content adjustments": "Regolazioni Contenuto",
    "Navigation adjustments": "Regolazioni Navigazione",
    "Text Align": "Allineamento del testo",
    "Align Left": "Allinea a sinistra",
    "Align Center": "Centra",
    "Align Right": "Allinea a destra",
    "Adjust Font Size": "Regola Dimensione Carattere",
    "Highlight Title": "Evidenzia Titolo",
    "Highlight Links": "Evidenzia Collegamenti",
    "Readable Font": "Carattere Leggibile",
    "Colour adjustments": "Regolazioni Colore",
    "Dark Contrast": "Contrasto Scuro",
    "Light Contrast": "Contrasto Chiaro",
    "High Contrast": "Alto Contrasto",
    "High Saturation": "Alta Saturazione",
    "Low Saturation": "Bassa Saturazione",
    "Monochrome": "Monocromatico",
    "Tools": "Strumenti",
    "Reading Guide": "Guida alla Lettura",
    "Big Cursor": "Cursore Grande",
    "Increase Font Size": "Aumenta Dimensione Carattere",
    "Decrease Font Size": "Diminuisci Dimensione Carattere",
    "Letter Spacing": "Spaziatura Lettere",
    "Line Height": "Altezza Riga",
    "Font Weight": "Spessore Carattere",
    "Dyslexia Font": "Carattere per Dislessia",
    "Language": "Lingua",
    "Accessibility widget": "Apri menu accessibilità",
    "Accessibility Profiles": "Profili di Accessibilità",
    "Cognitive Disability": "Disabilità Cognitiva",
    "Seizure Safe": "Sicuro per Epilessia",
    "Accessibility statement": "Dichiarazione di Accessibilità",
    "ADHD": "ADHD",
    "Low Vision": "Ipovisione",
    "Pause Animations": "Ferma Animazioni",
    "Animation paused": "Animazione in pausa",
    "Reset all settings": "Ripristina impostazioni",
    "Shortcut:": "Scorciatoia:",
    "Epilepsy Safe Mode": "Modalità sicura per l'epilessia",
    "Mute sounds": "Disattiva l'audio",
    "Page read": "Lettura della pagina",
    "Page read controls": "Controlli di lettura",
    "Pause": "Pausa",
    "Resume": "Riprendi",
    "Stop": "Ferma",
    "Settings": "Impostazioni",
    "Speed": "Velocità",
    "Voice": "Voce",
    "Close accessibility menu": "Chiudi il menu di accessibilità",
    "Back to accessibility menu": "Torna al menu di accessibilità",
    "Search languages": "Cerca lingue",
    "Selected language": "Lingua selezionata",
    "View accessibility statement (opens in new window)": "Visualizza la dichiarazione di accessibilità (si apre in una nuova finestra)",
    "Visit CookieYes website (opens in new window)": "Visita il sito web di CookieYes (si apre in una nuova finestra)",
    "Reset all accessibility settings to default": "Ripristina tutte le impostazioni di accessibilità"
}
